import { motion } from 'motion/react';
import { type FC, type PropsWithChildren, Suspense } from 'react';
import { pageMotionProps } from '../../motionFrame/animationConfig';

import { SuspenseLoader } from '../Loader/SuspenseLoader';

export const SuspensePage: FC<PropsWithChildren> = (props) => {
	return (
		<Suspense fallback={<SuspenseLoader />}>
			{
				<motion.div
					{...pageMotionProps}
					style={{ height: '100%', width: '100%' }}
				>
					{props.children}
				</motion.div>
			}
		</Suspense>
	);
};
